import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import cx from 'classnames';
import { appContext } from '../../util/decorators';
import translatedRoutes from '../../config/translatedRoutes';

const mapStateToProps = state => ({
  country: state.country,
});

@connect(mapStateToProps)
@withRouter
@appContext
export default class SearchForm extends React.PureComponent {
  static propTypes = {
    router: React.PropTypes.object.isRequired,
    isSearchVisible: React.PropTypes.bool.isRequired,
    onChange: React.PropTypes.func.isRequired,
  }

  onSubmit(evt, pathname) {
    evt.preventDefault();
    const query = {
      q: this.refs.searchInput.value,
    };
    this.props.router.push({ pathname, query });
    this.props.onChange();
  }

  render() {
    const { isSearchVisible, country } = this.props;
    const { url } = translatedRoutes[country].Search;
    const classnames = cx({
      'is-visible': isSearchVisible,
    });

    return (
      <div className={classnames}>
        <button
          className="search-button"
          onClick={this.props.onChange}>
          <span className="search-icon icon-magnifier"></span>
          <span className="search-text">
            {this.context.app.t('SearchForm.cancel')}
          </span>
        </button>

        {isSearchVisible ?
          <form action={url}
            className="search-form"
            onSubmit={evt => this.onSubmit(evt, url)}
          >
            <div className="search-input">
              <input type="search" name="s" ref="searchInput" autoFocus required autoComplete="off" maxLength="48" />
              <button className="search-reset" type="reset" onClick={() => this.refs.searchInput.focus()} />
            </div>
          </form>
        : null}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/component/Navigation/SearchForm.jsx